import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ExclamationSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ExclamationSVG;
